import { render } from "./PendingView.vue?vue&type=template&id=d1ff99f2"
import script from "./PendingView.vue?vue&type=script&lang=js"
export * from "./PendingView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__